export const ConnectServerLang = {
    inputPH: 'کد اتصال به سرور را وارد نمایید',
    connect: 'اتصال',
    question: 'ایا می خواهید وارد سرور شوید؟',
    enterAsker: 'ورود پرسشگر',
    enterPortal: 'کد اتصال به پورتال',
    error: 'کد اتصال شما صحیح نیست. لطفا مجدد تلاش نمایید',
};
